var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0925 13.1863L11.5878 2.75686C10.7994 1.49268 8.95506 1.50351 8.18151 2.77687L1.84577 13.2063C1.0361 14.5392 1.99559 16.2447 3.55509 16.2447H16.3955C17.9656 16.2447 18.9234 14.5185 18.0925 13.1863Z",
    stroke: "#E85555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87305 5.14771V11.4768",
    stroke: "#E85555"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.89428,
    cy: 13.3966,
    r: 0.864979,
    fill: "#E85555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.8aab6f3191fcd20480d107653adc57c3.svg";
export { ForwardRef as ReactComponent };